/**
 * Popup "permesso negato" per l'esecuzione on-demand dei job Prefect: lo mostrano i pulsanti
 * sempre visibili ("Esegui ora" su /jobs, «Avvia Scansione Vulnerabilità» nell'header) quando
 * l'utente non è amministratore.
 */

import { ModalPortal } from '../../components/ModalPortal.js';
import styles from './Prefect.module.css';

export function RunDenyPopup({
  sub,
  roles,
  onClose,
}: {
  sub?: string;
  roles: string[];
  onClose: () => void;
}) {
  return (
    <ModalPortal onClose={onClose}>
      <div className={styles.denyOverlay} data-testid="run-deny-popup" onClick={onClose}>
        <div className={styles.denyPanel} role="alertdialog" onClick={(e) => e.stopPropagation()}>
          <p className={styles.denyTitle}>Il tuo ruolo/utente non può eseguire questo job.</p>
          <p className={styles.denyDetail}>
            Utente: <strong>{sub ?? '—'}</strong> · Ruoli: {roles.length ? roles.join(', ') : '—'}
          </p>
          <p className={styles.denyDetail}>
            L&apos;esecuzione on-demand richiede il ruolo <code>admin</code>.
          </p>
          <button
            type="button"
            className={styles.runNowButton}
            onClick={onClose}
            data-testid="btn-chiudi-deny"
          >
            Chiudi
          </button>
        </div>
      </div>
    </ModalPortal>
  );
}
